<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('tasktypes.title')"/>

        <Transition name="fade">
            <task-type-list
                :results="results"
                @add="addTaskType"
                @edit="editTaskType"
            />
        </Transition>

        <base-modal size="lg" v-if="editMode" hide-footer hide-header @close="showTaskTypeList">
            <task-type-editor
                :task-type="taskType"
                @close="showTaskTypeList"
                @closeAndUpdate="closeAndUpdate"
            />
        </base-modal>

        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import TaskTypeList from './TaskTypeList'
import TaskTypeEditor from './TaskTypeEditor'
import CompanyFilter from '../company/CompanyFilter'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'TaskTypes',
    components: {BaseModal, Navbar, CompanyFilter, TaskTypeList, TaskTypeEditor},
    mixins: [restApi, workManagementHelper],
    data: function () {
        return {
            results: [],
            taskType: null,
            editMode: false,
            loading: false,
            searchCompanyId: null,
            company: null
        }
    },
    watch: {
        company: function () {
            this.fetchTaskTypes(this.company)
        }
    },
    mounted: function () {
        this.fetchTaskTypes()
    },
    methods: {
        fetchTaskTypes: function (companyId) {
            this.loading = true
            this.results = []
            this.searchCompanyId = companyId
            this.restFetchParams(this.taskTypeUrl, {company: this.searchCompanyId}, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        addTaskType: function () {
            this.taskType = this.newTaskType()
            this.editMode = true
        },
        editTaskType: function (taskType) {
            this.taskType = taskType
            this.editMode = true
        },
        showTaskTypeList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchTaskTypes(this.searchCompanyId)
            this.showTaskTypeList()
        }

    }
}
</script>
